export enum TimeOffRequestType {
    Other = 0,
    Maternal = 100,
    Holiday = 200,
    Medical = 300,
    Study = 400
}
